import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Header from "./Layouts/Header";
import Footer from "./Layouts/Footer";
import Home from "./Screen/Home";
import Login from "./Screen/Auth/Login";
import Register from "./Screen/Auth/Register";
import AboutUs from "./Screen/AboutUs";
import NewArrivals from "./Screen/Products/NewArrivals";
import Faq from "./Screen/Faq";
import Cart from "./Screen/Products/Cart";
import ProductDetails from "./Screen/Products/ProductDetails";
import PrivacyPolicy from "./Screen/PrivacyPolicy";
import Gift from "./Screen/Products/Gift";
import Checkout from "./Screen/Products/Checkout";
import ForgotPassword from "./Screen/Auth/ForgotPassword";
import Location from "./Screen/Location";
import Instruction from "./Screen/Instruction";
import LocationSecond from "./Screen/LocationSecond";

function App() {
  const location_new = useLocation();
  const hideFooterRoutes = ["/locations"];
  const shouldHideFooter = hideFooterRoutes.includes(location_new.pathname);

  return (
    <div className="App">
      <div className="site-wrapper">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/new-arrivals" element={<NewArrivals />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/product-detail" element={<ProductDetails />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/gift-coupon" element={<Gift />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/location" element={<Location />} />
          <Route path="/instructions" element={<Instruction />} />
          <Route path="/locations" element={<LocationSecond />} />
        </Routes>
        {!shouldHideFooter && <Footer />}
      </div>
    </div>
  );
}

export default App;
